import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'content'];

  show() {
    this.contentTargets.forEach((content) => content.classList.remove('hidden'));
    this.triggerTargets.forEach((trigger) => trigger.classList.add('hidden'));
  }
}
